import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id BBDD4244-D5C9-4150-9936-31C775AA463F
 * name led-variant-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/led-variant-off.svg
 * tags
 * - Home Automation 
 */
export const LedVariantOffIcon = createSvgIcon(<><path d="M12,3C10.05,3 8.43,4.4 8.08,6.25L16.82,15H18V13H16V7A4,4 0 0,0 12,3M3.28,4L2,5.27L8,11.27V13H6V15H9V21H11V15H11.73L13,16.27V21H15V18.27L18.73,22L20,20.72L15,15.72L8,8.72L3.28,4Z" /></>, 'LedVariantOffIcon');
export default LedVariantOffIcon